import PropTypes from 'prop-types';
import React, { useState } from 'react';

import ModuleDispatcher from './module-dispatcher.jsx';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const ModuleNarrowSectionBlock = ({
    content,
    heading,
}) => {
    const firstAccordion = content?.find((item) => item.__typename === 'NarrowAccordionBlock');

    const [firstAccordionId] = useState(firstAccordion?.id);

    return (
        <>
            <div className='pt-60 block md:hidden layout-container'>
                {heading && (
                    <h2 className='type-style-3 text-left'>
                        {heading}
                    </h2>
                )}
            </div>

            {content?.map((module, idx) => {
                if (module.__typename === 'NarrowAccordionBlock') {
                    module.isFirstAccordion = (module.id === firstAccordionId);
                }

                module.borderBottom = false;
                module.borderTop = false;

                return (
                    <ModuleDispatcher
                        index={idx}
                        isAccordionOrSection={true}
                        key={idx}
                        sectionHeading={heading}
                        {...module} />
                );
            })}
        </>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    content: PropTypes.array,
    ctaLabel: PropTypes.string,
    ctaUrl: PropTypes.object,
    heading: PropTypes.string,
    index: PropTypes.number,
    sectionBody: PropTypes.string
};

ModuleNarrowSectionBlock.propTypes = propTypes;

export default ModuleNarrowSectionBlock;
